/* eslint-disable @stylexjs/no-unused -- styles are looked up by runtime key */
import * as stylex from '@stylexjs/stylex';
import { theme } from 'trellis-theming/theme.stylex';
const marginBlockStyles = {
  "0": {
    marginBlock: "x866bh7",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "100": {
    marginBlock: "x1licjgx",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "200": {
    marginBlock: "x1x1sxb",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "300": {
    marginBlock: "x6zseco",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "400": {
    marginBlock: "xy1ta4t",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "600": {
    marginBlock: "xc4a6le",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "800": {
    marginBlock: "xr13kb1",
    marginTop: null,
    marginBottom: null,
    $$css: true
  }
};
const marginBlockStartStyles = {
  "0": {
    marginTop: "x155yy3l",
    $$css: true
  },
  "100": {
    marginTop: "xp050ak",
    $$css: true
  },
  "200": {
    marginTop: "xfekf6i",
    $$css: true
  },
  "300": {
    marginTop: "x1ni6mix",
    $$css: true
  },
  "400": {
    marginTop: "x1nmqnbi",
    $$css: true
  },
  "600": {
    marginTop: "xj0smu1",
    $$css: true
  },
  "800": {
    marginTop: "x1qr4740",
    $$css: true
  }
};
const marginBlockEndStyles = {
  "0": {
    marginBottom: "x1fd4wat",
    $$css: true
  },
  "100": {
    marginBottom: "xzm6cv2",
    $$css: true
  },
  "200": {
    marginBottom: "x7vqod3",
    $$css: true
  },
  "300": {
    marginBottom: "x1qgg3u0",
    $$css: true
  },
  "400": {
    marginBottom: "xbervng",
    $$css: true
  },
  "600": {
    marginBottom: "xots3vl",
    $$css: true
  },
  "800": {
    marginBottom: "x6b0qdr",
    $$css: true
  }
};
const marginInlineStyles = {
  "0": {
    marginInline: "x1nslej5",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "100": {
    marginInline: "xhqhiy8",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "200": {
    marginInline: "x1fie8z3",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "300": {
    marginInline: "xouzovm",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "400": {
    marginInline: "x1w4d6r1",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "600": {
    marginInline: "x1ls5k6g",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "800": {
    marginInline: "x1oxhrdy",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  }
};
const marginInlineStartStyles = {
  "0": {
    marginInlineStart: "xs7sr93",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "100": {
    marginInlineStart: "xia198q",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "200": {
    marginInlineStart: "x1lecetj",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "300": {
    marginInlineStart: "x4bvc99",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "400": {
    marginInlineStart: "x1ocenht",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "600": {
    marginInlineStart: "x14fse72",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "800": {
    marginInlineStart: "x1cjlyrh",
    marginLeft: null,
    marginRight: null,
    $$css: true
  }
};
const marginInlineEndStyles = {
  "0": {
    marginInlineEnd: "x1qqae4",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "100": {
    marginInlineEnd: "xm4u3c4",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "200": {
    marginInlineEnd: "xxj5nmu",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "300": {
    marginInlineEnd: "x18vbul1",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "400": {
    marginInlineEnd: "xh522qj",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "600": {
    marginInlineEnd: "x16i5gv0",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "800": {
    marginInlineEnd: "xxjam05",
    marginLeft: null,
    marginRight: null,
    $$css: true
  }
};
const MARGIN_STYLES = {
  marginBlock: marginBlockStyles,
  marginBlockStart: marginBlockStartStyles,
  marginBlockEnd: marginBlockEndStyles,
  marginInline: marginInlineStyles,
  marginInlineStart: marginInlineStartStyles,
  marginInlineEnd: marginInlineEndStyles
};
const MARGIN_PROPS = Object.keys(MARGIN_STYLES);
export const toMarginXstyle = props => MARGIN_PROPS.flatMap(prop => {
  const value = props[prop];
  const styles = MARGIN_STYLES[prop];
  const style = value === undefined ? undefined : styles[value];
  return style ? [style] : [];
});